export default () => ({
    faqActive: false,
    faqData: '',
    loading: false,
});